module.exports = __webpack_public_path__ + "media/images/area/feature/common/icon_arrow-dd8f955f9136527c83af4ea235d69959.svg";